import angular from 'angular'
import envRaw from '../utils/env-raw'
import StrictObj from '../utils/strict-obj'

import Template from './ggs-spinner.directive.ejs'
import SPINNER_ICON from '../../img/spinner-icons/normal.svg'

angular
  .module('ggs.spinner')
  .directive('ggsSpinner', SpinnerDirective)

function SpinnerDirective() {
  return {
    restrict: 'E',
    template: Template(StrictObj({
      LE: envRaw.liveEditMode,
      SPINNER_ICON
    }))
  }
}
